import React, { useMemo } from "react";
import { useData } from "../../context/DataContext";
import { useAuth } from "../../context/AuthContext";
import { userMatchesField, cellText } from "../../utils/helpers";
import TaskTable from "../../components/TaskTable";
import { USER_TABLE } from "../../context/DataContext";

export default function OverdueTasks() {
  const { userRecords, loading } = useData();
  const { user } = useAuth();

  const overdue = useMemo(() =>
    userRecords.filter((r) => {
      const isMine = r.user_id === user?.userId;
      if (!isMine) return false;
      const end = r.fields?.["End Date"];
      const isPast = end && end < Date.now();
      return isPast && !r.fields?.["My Completion"];
    }),
    [userRecords, user]
  );

  if (loading && userRecords.length === 0) return <div className="loading-box"><div className="spinner" /><span>Loading...</span></div>;

  return (
    <div className="fade-in">
      <div className="page-header">
        <h1>🔴 Overdue Tasks</h1>
        <p>Tasks that have passed their deadline — {overdue.length} records</p>
      </div>

      {overdue.length > 0 && (
        <div className="alert alert-error" style={{ marginBottom: 20 }}>
          ⚠ You have <strong>{overdue.length}</strong> overdue task{overdue.length > 1 ? "s" : ""}. Please take action immediately.
        </div>
      )}

      <TaskTable 
        tableId={USER_TABLE} 
        records={overdue} 
        emptyMsg="No overdue tasks. You're on track! 🎯" 
        canComplete 
        hideStatusFilter={true}
      />
    </div>
  );
}
